import { motion } from "framer-motion";

export function PageHeader({ title, subtitle, actions, testId }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8"
            data-testid={testId || "page-header"}
        >
            <div>
                <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight">{title}</h1>
                {subtitle && <p className="text-muted-foreground mt-1.5 text-sm">{subtitle}</p>}
            </div>
            {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
        </motion.div>
    );
}

export function GlassCard({ className = "", children, ...rest }) {
    return (
        <div
            className={`glass rounded-2xl shadow-[0_4px_24px_rgba(15,23,42,0.04)] dark:shadow-[0_4px_24px_rgba(0,0,0,0.3)] ${className}`}
            {...rest}
        >
            {children}
        </div>
    );
}

export function EmptyState({ icon: Icon, title, description, action, testId }) {
    return (
        <div className="text-center py-14 px-6" data-testid={testId || "empty-state"}>
            {Icon && (
                <div className="inline-flex w-14 h-14 rounded-2xl bg-primary/10 text-primary items-center justify-center mb-4">
                    <Icon className="w-6 h-6" />
                </div>
            )}
            <h3 className="font-heading text-lg font-semibold">{title}</h3>
            {description && <p className="text-muted-foreground text-sm mt-1.5 max-w-md mx-auto">{description}</p>}
            {action && <div className="mt-5">{action}</div>}
        </div>
    );
}

export function Skeleton({ className = "" }) {
    return <div className={`bg-muted/60 animate-pulse rounded-lg ${className}`} />;
}

export function StatusBadge({ status }) {
    const map = {
        active: "bg-success/10 text-success",
        present: "bg-success/10 text-success",
        on_leave: "bg-warning/10 text-warning",
        exited: "bg-destructive/10 text-destructive",
        archived: "bg-muted text-muted-foreground",
        pending: "bg-warning/15 text-warning",
        approved: "bg-success/10 text-success",
        rejected: "bg-destructive/10 text-destructive",
        applied: "bg-blue-500/10 text-blue-500",
        shortlisted: "bg-indigo-500/10 text-indigo-500",
        interview: "bg-amber-500/10 text-amber-500",
        assessment: "bg-purple-500/10 text-purple-500",
        selected: "bg-success/10 text-success",
        open: "bg-success/10 text-success",
        closed: "bg-muted text-muted-foreground",
    };
    return (
        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold capitalize ${map[status] || "bg-muted text-muted-foreground"}`}>
            {(status || "").replace("_", " ")}
        </span>
    );
}
